module.exports = __webpack_public_path__ + "media/images/talent/flow01-ba4ee75b8bea719dfea15eb69a75ae9f.png";